// export const apiUrl = 'http://192.168.1.204:8000/apis/';
// export const assetsUrl = 'http://192.168.1.204:8000/apis/';

// export const apiUrl = 'http://127.0.0.1:8000/apis/';
// export const assetsUrl = 'http://127.0.0.1:8000/apis/';

// export const apiUrl = 'https://fieldapp.sobha-galera-hoskote.com/apibackend/apis/';
// export const assetsUrl = 'https://fieldapp.sobha-galera-hoskote.com/apibackend/apis/';

export const apiUrl = 'https://fieldapp.consulthagnos.in.net/apibackend/apis/';
export const assetsUrl = 'https://fieldapp.consulthagnos.in.net/apibackend/apis/';